import { Injectable } from '@angular/core';

export const RADIO_GROUP_NAME = 'cms_radio_group_';
export const SELECT_NAME = 'cms_select_';
export const DATEPICKER_NAME = 'cms_datepicker_';

@Injectable()
export class FormFieldUniqNames {
  private radiosGroupsCnt = 0;
  private selectsCnt = 0;

  getRadioGroupName() {
    return `${RADIO_GROUP_NAME}${this.radiosGroupsCnt++}`;
  }

  getSelectName() {
    return `${SELECT_NAME}${this.selectsCnt++}`;
  }
}
